import { render, staticRenderFns } from "./cpt-sh.vue?vue&type=template&id=822952f6&scoped=true"
import script from "./cpt-sh.vue?vue&type=script&lang=js"
export * from "./cpt-sh.vue?vue&type=script&lang=js"
import style0 from "./cpt-sh.vue?vue&type=style&index=0&id=822952f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822952f6",
  null
  
)

export default component.exports